module.exports = __webpack_public_path__ + "img/cat_chasing_light.bcd5ee11.jpg";